var map = {
	"./bet575/images/close-filter.svg": 1163,
	"./bet575/images/logo/logoMb.svg": 1164,
	"./bet777/icons/horse.svg": 1165,
	"./bet777/icons/soccer-1.svg": 1166,
	"./bet777/images/close-filter.svg": 1167,
	"./bet777/images/logo.svg": 1168,
	"./bet777/images/logoMb.svg": 1169,
	"./betgalaxy/icons/qamAccountOverview.svg": 1170,
	"./betgalaxy/icons/qamLogOut.svg": 1171,
	"./betgalaxy/icons/qamMyBets.svg": 1172,
	"./betgalaxy/icons/qamSupport.svg": 1173,
	"./betgalaxy/images/betslip/betSlipIcon.svg": 1174,
	"./betgalaxy/images/betslip/closeButton.svg": 1175,
	"./betgalaxy/images/betslip/estReturnIcon.svg": 1176,
	"./betgalaxy/images/emptyBetslip.svg": 1177,
	"./betgalaxy/images/logo.svg": 1178,
	"./betgalaxy/images/logoMobile.svg": 1179,
	"./betgalaxy/images/switch/blue-ufo.svg": 1180,
	"./betgalaxy/images/switch/green-ufo.svg": 1181,
	"./betgalaxy/images/switch/moon.svg": 1182,
	"./betprofessor/icons/ContactUs.svg": 1183,
	"./betprofessor/icons/MultiBet.svg": 1184,
	"./betprofessor/icons/MyAccount.svg": 1185,
	"./betprofessor/icons/Promo.svg": 1186,
	"./betprofessor/images/logo.svg": 1187,
	"./betprofessor/images/logo/logo.svg": 1188,
	"./betprofessor/images/racing/fav.svg": 1189,
	"./betroyale/icons/ContactUs.svg": 1190,
	"./betroyale/icons/Deposit.svg": 1191,
	"./betroyale/icons/Greyhounds.svg": 1192,
	"./betroyale/icons/Home.svg": 1193,
	"./betroyale/icons/MyAccount.svg": 1194,
	"./betroyale/icons/Promo.svg": 1195,
	"./betroyale/icons/Promotions.svg": 1196,
	"./betroyale/icons/ScrewWrench.svg": 1197,
	"./betroyale/icons/Sports.svg": 1198,
	"./betroyale/icons/horse_racing.svg": 1199,
	"./betroyale/images/backgrounds/battlements.svg": 1200,
	"./betroyale/images/header/cards.svg": 1201,
	"./betroyale/images/logo.svg": 1202,
	"./betroyale/images/logos/logo-desktop.svg": 1203,
	"./betroyale/images/logos/logo-mobile.svg": 1204,
	"./betroyale/images/nav/crown.svg": 1205,
	"./betstride/images/backgrounds/BetStrideBorder.svg": 1206,
	"./betstride/images/close-filter.svg": 1207,
	"./betstride/images/gradient-border.svg": 1208,
	"./betstride/images/switch/gradient-border.svg": 1209,
	"./buffalobet/images/backgrounds/onboardingLogo.svg": 1210,
	"./buffalobet/images/close-filter.svg": 1211,
	"./buffalobet/images/error/logoErr.svg": 1212,
	"./buffalobet/images/footer/logoFooter.svg": 1213,
	"./buffalobet/images/logo.svg": 1214,
	"./buffalobet/images/logoMb.svg": 1215,
	"./chromabet/icons/MultiBet.svg": 1216,
	"./core/badges/aqua-runner.svg": 910,
	"./core/badges/away-early.svg": 911,
	"./core/badges/best-rated.svg": 912,
	"./core/badges/box-specialist.svg": 913,
	"./core/badges/champion-dog.svg": 914,
	"./core/badges/champion-horse.svg": 915,
	"./core/badges/consistent-performer.svg": 916,
	"./core/badges/distance-expert.svg": 917,
	"./core/badges/donkey.svg": 918,
	"./core/badges/dynamic-duo.svg": 919,
	"./core/badges/early-away.svg": 920,
	"./core/badges/favourite-distance.svg": 921,
	"./core/badges/featherweight-champion.svg": 922,
	"./core/badges/first-timer.svg": 923,
	"./core/badges/hercules.svg": 924,
	"./core/badges/last-start-winner.svg": 925,
	"./core/badges/likes-the-ground.svg": 926,
	"./core/badges/mile-high.svg": 927,
	"./core/badges/picket-fence.svg": 928,
	"./core/badges/place-performer.svg": 929,
	"./core/badges/ready-to-go.svg": 930,
	"./core/badges/returning-from-rest.svg": 931,
	"./core/badges/roughie.svg": 932,
	"./core/badges/striking-distance.svg": 933,
	"./core/badges/strong-finisher.svg": 934,
	"./core/badges/strong-home-section.svg": 935,
	"./core/badges/top-pedigree.svg": 936,
	"./core/badges/track-specialist.svg": 937,
	"./core/badges/well-rested.svg": 938,
	"./core/icons/BetRefund-Notification.svg": 533,
	"./core/icons/BetWon-Notification.svg": 534,
	"./core/icons/BonusBet-Notification.svg": 535,
	"./core/icons/ContactUs.svg": 536,
	"./core/icons/Deposit.svg": 537,
	"./core/icons/GaugeHighSolid.svg": 538,
	"./core/icons/LiveChat.svg": 539,
	"./core/icons/Logo2.svg": 540,
	"./core/icons/QRacingQueensland.svg": 541,
	"./core/icons/RWWA.svg": 542,
	"./core/icons/RacingNSW.svg": 543,
	"./core/icons/ResponsibleGambling.svg": 544,
	"./core/icons/TasRacing.svg": 545,
	"./core/icons/ThoroughbredPark.svg": 546,
	"./core/icons/accountUnverified.svg": 547,
	"./core/icons/accountVerified.svg": 548,
	"./core/icons/afl_football.svg": 549,
	"./core/icons/all_sports.svg": 550,
	"./core/icons/american_football.svg": 551,
	"./core/icons/angleRightSolid.svg": 552,
	"./core/icons/applepay.svg": 553,
	"./core/icons/arrowDown.svg": 554,
	"./core/icons/arrowUp.svg": 555,
	"./core/icons/australian_rules.svg": 556,
	"./core/icons/badminton.svg": 557,
	"./core/icons/baseball.svg": 558,
	"./core/icons/basketball.svg": 559,
	"./core/icons/beach_volleyball.svg": 560,
	"./core/icons/bonusBetIcon.svg": 561,
	"./core/icons/box_challenge.svg": 562,
	"./core/icons/boxing.svg": 563,
	"./core/icons/calendar.svg": 564,
	"./core/icons/cashout.svg": 565,
	"./core/icons/contact_us.svg": 566,
	"./core/icons/cricket.svg": 567,
	"./core/icons/cycling.svg": 568,
	"./core/icons/darts.svg": 569,
	"./core/icons/default.svg": 570,
	"./core/icons/depositDirect.svg": 571,
	"./core/icons/dropdownArrow.svg": 572,
	"./core/icons/ellipsis.svg": 573,
	"./core/icons/emptyBetSlip.svg": 574,
	"./core/icons/emptyMultiIcon.svg": 575,
	"./core/icons/eye.svg": 576,
	"./core/icons/eyeSlash.svg": 577,
	"./core/icons/facebook.svg": 578,
	"./core/icons/field_hockey.svg": 579,
	"./core/icons/fighting.svg": 580,
	"./core/icons/football.svg": 581,
	"./core/icons/golf.svg": 582,
	"./core/icons/greyhounds.svg": 583,
	"./core/icons/harness_racing.svg": 584,
	"./core/icons/horseRacingIcon.svg": 585,
	"./core/icons/horse_racing.svg": 586,
	"./core/icons/ice_hockey.svg": 587,
	"./core/icons/iconAlert.svg": 588,
	"./core/icons/iconAlertYellow.svg": 589,
	"./core/icons/iconCheckMarkCircle.svg": 590,
	"./core/icons/jockey_challenge.svg": 591,
	"./core/icons/key.svg": 592,
	"./core/icons/keypadDelete.svg": 593,
	"./core/icons/lawn_bowls.svg": 594,
	"./core/icons/leftArrowWall.svg": 595,
	"./core/icons/lifeRaft.svg": 596,
	"./core/icons/loadingspinner.svg": 597,
	"./core/icons/log_out.svg": 598,
	"./core/icons/logout.svg": 599,
	"./core/icons/mastercard.svg": 600,
	"./core/icons/mb-logo.svg": 601,
	"./core/icons/megaphone.svg": 602,
	"./core/icons/mma.svg": 603,
	"./core/icons/money-back.svg": 604,
	"./core/icons/motor_racing.svg": 605,
	"./core/icons/motor_sport.svg": 606,
	"./core/icons/multi_betslip.svg": 607,
	"./core/icons/navBars.svg": 608,
	"./core/icons/netball.svg": 609,
	"./core/icons/passwordPeek.svg": 610,
	"./core/icons/paymentTick.svg": 611,
	"./core/icons/paymentX.svg": 612,
	"./core/icons/person.svg": 613,
	"./core/icons/personAdd.svg": 614,
	"./core/icons/politics.svg": 615,
	"./core/icons/presentforMark.svg": 616,
	"./core/icons/promPref.svg": 617,
	"./core/icons/racing.svg": 618,
	"./core/icons/racing_extras.svg": 619,
	"./core/icons/rightArrow.svg": 620,
	"./core/icons/rugby_league.svg": 621,
	"./core/icons/rugby_union.svg": 622,
	"./core/icons/sideNavClose.svg": 623,
	"./core/icons/snooker.svg": 624,
	"./core/icons/soccer.svg": 625,
	"./core/icons/specials.svg": 626,
	"./core/icons/spinArrow.svg": 627,
	"./core/icons/sport_futures.svg": 628,
	"./core/icons/sports_az.svg": 629,
	"./core/icons/sports_exotics.svg": 630,
	"./core/icons/sports_futures.svg": 631,
	"./core/icons/squareStack.svg": 632,
	"./core/icons/square_question.svg": 633,
	"./core/icons/square_right.svg": 634,
	"./core/icons/surfing.svg": 635,
	"./core/icons/table_tennis.svg": 636,
	"./core/icons/tennis-australia-logo.svg": 637,
	"./core/icons/tennis.svg": 638,
	"./core/icons/thumbsUp.svg": 639,
	"./core/icons/todays_offers.svg": 640,
	"./core/icons/tooltip-icon.svg": 641,
	"./core/icons/treasure_chest.svg": 642,
	"./core/icons/triangleDown.svg": 643,
	"./core/icons/twitter.svg": 644,
	"./core/icons/visa.svg": 645,
	"./core/icons/volleyball.svg": 646,
	"./core/images/accountUnverified.svg": 1217,
	"./core/images/accountVerified.svg": 1218,
	"./core/images/androidButton.svg": 1219,
	"./core/images/arrowDown.svg": 1220,
	"./core/images/arrowUp.svg": 1221,
	"./core/images/banner/desktop.svg": 1222,
	"./core/images/banner/mobile.svg": 1223,
	"./core/images/calendar.svg": 1224,
	"./core/images/defaultSilk.svg": 1225,
	"./core/images/dropdownArrow.svg": 1226,
	"./core/images/ellipsis.svg": 1227,
	"./core/images/emptyBetSlip.svg": 1228,
	"./core/images/facebook.svg": 1229,
	"./core/images/horseRacingIcon.svg": 1230,
	"./core/images/iconAlert.svg": 1231,
	"./core/images/iconAlertYellow.svg": 1232,
	"./core/images/iconCheckMarkCircle.svg": 1233,
	"./core/images/iosButton.svg": 1234,
	"./core/images/key.svg": 1235,
	"./core/images/keypadDelete.svg": 1236,
	"./core/images/leftArrowWall.svg": 1237,
	"./core/images/lifeRaft.svg": 1238,
	"./core/images/logo.svg": 1239,
	"./core/images/navBars.svg": 1240,
	"./core/images/passwordPeek.svg": 1241,
	"./core/images/person.svg": 1242,
	"./core/images/personAdd.svg": 1243,
	"./core/images/rightArrow.svg": 1244,
	"./core/images/sideNavClose.svg": 1245,
	"./core/images/spinArrow.svg": 1246,
	"./core/images/sports/afl.svg": 1247,
	"./core/images/sports/afl_football.svg": 1248,
	"./core/images/sports/american_football.svg": 1249,
	"./core/images/sports/badminton.svg": 1250,
	"./core/images/sports/baseball.svg": 1251,
	"./core/images/sports/basketball.svg": 1252,
	"./core/images/sports/beach_volleyball.svg": 1253,
	"./core/images/sports/box_challenge.svg": 1254,
	"./core/images/sports/boxing.svg": 1255,
	"./core/images/sports/cricket.svg": 1256,
	"./core/images/sports/cycling.svg": 1257,
	"./core/images/sports/darts.svg": 1258,
	"./core/images/sports/default.svg": 1259,
	"./core/images/sports/field_hockey.svg": 1260,
	"./core/images/sports/golf.svg": 1261,
	"./core/images/sports/greyhounds.svg": 1262,
	"./core/images/sports/harness_racing.svg": 1263,
	"./core/images/sports/horse_racing.svg": 1264,
	"./core/images/sports/ice_hockey.svg": 1265,
	"./core/images/sports/jockey_challenge.svg": 1266,
	"./core/images/sports/lawn_bowls.svg": 1267,
	"./core/images/sports/motor_sport.svg": 1268,
	"./core/images/sports/politics.svg": 1269,
	"./core/images/sports/racing.svg": 1270,
	"./core/images/sports/racing_extras.svg": 1271,
	"./core/images/sports/rugby_league.svg": 1272,
	"./core/images/sports/rugby_union.svg": 1273,
	"./core/images/sports/snooker.svg": 1274,
	"./core/images/sports/soccer.svg": 1275,
	"./core/images/sports/sports_exotics.svg": 1276,
	"./core/images/sports/square_question.svg": 1277,
	"./core/images/sports/surfing.svg": 1278,
	"./core/images/sports/tennis.svg": 1279,
	"./core/images/sports/todays_offers.svg": 1280,
	"./core/images/squareStack.svg": 1281,
	"./core/images/triangleDown.svg": 1282,
	"./core/images/twitter.svg": 1283,
	"./epicodds/icons/ContactUsEO.svg": 1284,
	"./epicodds/icons/DepositEO.svg": 1285,
	"./epicodds/icons/MyAccountEO.svg": 1286,
	"./epicodds/icons/PromoEO.svg": 1287,
	"./epicodds/icons/ResponsibleGamblingEO.svg": 1288,
	"./epicodds/icons/SportsEO.svg": 1289,
	"./epicodds/images/close-filter.svg": 1290,
	"./fiestabet/icons/ContactUs.svg": 1291,
	"./fiestabet/icons/Deposit.svg": 1292,
	"./fiestabet/icons/Home.svg": 1293,
	"./fiestabet/icons/LiveChat.svg": 1294,
	"./fiestabet/icons/MyAccount.svg": 1295,
	"./fiestabet/icons/Promo.svg": 1296,
	"./fiestabet/icons/Sports.svg": 1297,
	"./fiestabet/icons/horsey.svg": 1298,
	"./fiestabet/images/backgrounds/mobileBackground.svg": 1299,
	"./fiestabet/images/loader.svg": 1300,
	"./fiestabet/images/logo-mobile.svg": 1301,
	"./fiestabet/images/logo.svg": 1302,
	"./fiestabet/images/mobile_logo.svg": 1303,
	"./fiestabet/images/switch/old-board.svg": 1304,
	"./fiestabet/images/switch/skull-coin.svg": 1305,
	"./forsport/images/homeFeaturedSport/limitsv.svg": 1306,
	"./forsport/images/logo-brand.svg": 1307,
	"./forsport/images/volleyball.svg": 1308,
	"./gigabet/icons/ContactUsGG.svg": 1309,
	"./gigabet/icons/DepositGG.svg": 1310,
	"./gigabet/icons/MyAccountGG.svg": 1311,
	"./gigabet/icons/ResponsibleGambling.svg": 1312,
	"./gigabet/icons/SportsGG.svg": 1313,
	"./gigabet/images/close-filter.svg": 1314,
	"./gigabet/images/racing/mysteryBetLogo.svg": 1315,
	"./gigabet/images/toggle/toggleInner.svg": 1316,
	"./gigabet/images/toggle/toggleOuter.svg": 1317,
	"./gigabet/images/toggle/toggleTick.svg": 1318,
	"./goldenbet888/icons/ContactUs888.svg": 1319,
	"./goldenbet888/icons/Deposit888.svg": 1320,
	"./goldenbet888/icons/MyAccount888.svg": 1321,
	"./goldenbet888/icons/ResponsibleGambling888.svg": 1322,
	"./goldenbet888/icons/Sports888.svg": 1323,
	"./goldenbet888/images/close-filter.svg": 1324,
	"./goldenbet888/images/sideNav/squigglyBorder.svg": 1325,
	"./goldenrush/icons/greyhounds.svg": 1326,
	"./goldenrush/icons/harness_racing.svg": 1327,
	"./goldenrush/icons/horse_racing.svg": 1328,
	"./goldenrush/icons/loadingspinner.svg": 1329,
	"./goldenrush/images/logo.svg": 1330,
	"./goldenrush/images/logoFooter.svg": 1331,
	"./hyperbet/icons/ContactUsHB.svg": 1332,
	"./hyperbet/icons/DepositHB.svg": 1333,
	"./hyperbet/icons/HomeHB.svg": 1334,
	"./hyperbet/icons/MyAccountHB.svg": 1335,
	"./hyperbet/icons/PromoHB.svg": 1336,
	"./hyperbet/icons/ResponsibleGambling.svg": 1337,
	"./hyperbet/icons/SportsHB.svg": 1338,
	"./hyperbet/images/close-filter.svg": 1339,
	"./juicybet/icons/all_sports.svg": 1340,
	"./juicybet/icons/boxing.svg": 1341,
	"./juicybet/icons/contactUs.svg": 1342,
	"./juicybet/icons/cricket.svg": 1343,
	"./juicybet/icons/deposit.svg": 1344,
	"./juicybet/icons/greyhounds.svg": 1345,
	"./juicybet/icons/harness_racing.svg": 1346,
	"./juicybet/icons/home.svg": 1347,
	"./juicybet/icons/horse_racing.svg": 1348,
	"./juicybet/icons/my_account.svg": 1349,
	"./juicybet/icons/promotions.svg": 1350,
	"./junglebet/images/logos/logoDesktop.svg": 1351,
	"./junglebet/images/switch/vineLeft.svg": 1352,
	"./junglebet/images/switch/vineRight.svg": 1353,
	"./magnumbet/images/close-filter.svg": 1354,
	"./puntcity/icons/ContactUs.svg": 1355,
	"./puntcity/icons/Deposit.svg": 1356,
	"./puntcity/icons/Home.svg": 1357,
	"./puntcity/icons/MyAccount.svg": 1358,
	"./puntcity/icons/Promo.svg": 1359,
	"./puntcity/icons/Sports.svg": 1360,
	"./puntcity/images/cityClosed.svg": 1361,
	"./puntcity/images/homeFeaturedSport/limitsv.svg": 1362,
	"./puntcity/images/logo.svg": 1363,
	"./puntgenie/icons/ContactUs.svg": 1364,
	"./puntgenie/icons/Deposit.svg": 1365,
	"./puntgenie/icons/Home.svg": 1366,
	"./puntgenie/icons/MyAccount.svg": 1367,
	"./puntgenie/icons/Promo.svg": 1368,
	"./puntgenie/icons/ScrewWrench.svg": 1369,
	"./puntgenie/icons/Sports.svg": 1370,
	"./puntgenie/images/logo.svg": 1371,
	"./puntgenie/images/logoMobile.svg": 1372,
	"./puntgenie/images/switch/ruby.svg": 1373,
	"./pyramidbet/images/border/borderDark2Light.svg": 1374,
	"./pyramidbet/images/border/borderLight2Dark.svg": 1375,
	"./pyramidbet/images/close-filter.svg": 1376,
	"./questbet/icons/ContactUs.svg": 1377,
	"./questbet/icons/Home.svg": 1378,
	"./questbet/icons/MyAccount.svg": 1379,
	"./questbet/icons/Promo.svg": 1380,
	"./questbet/icons/ScrewWrench.svg": 1381,
	"./questbet/images/backgrounds/get-verified.svg": 1382,
	"./questbet/images/header/qblogo-white.svg": 1383,
	"./questbet/images/logo.svg": 1384,
	"./questbet/images/mobile_logo.svg": 1385,
	"./questbet/images/nav/coins.svg": 1386,
	"./questbet/images/nav/ninjauser.svg": 1387,
	"./questbet/images/toggle/toggle.svg": 1388,
	"./slambet/icons/ContactUs.svg": 1389,
	"./slambet/icons/DepositSlam.svg": 1390,
	"./slambet/icons/MyAccount.svg": 1391,
	"./slambet/icons/ResponsibleGambling.svg": 1392,
	"./slambet/icons/Sports.svg": 1393,
	"./slambet/images/backgrounds/gradientBorderSmall.svg": 1394,
	"./slambet/images/backgrounds/iconBg.svg": 1395,
	"./slambet/images/backgrounds/slamBorder.svg": 1396,
	"./slambet/images/close-filter.svg": 1397,
	"./sterlingparker/icons/ContactUs.svg": 1398,
	"./sterlingparker/icons/Deposit.svg": 1399,
	"./sterlingparker/icons/Home.svg": 1400,
	"./sterlingparker/icons/LiveChat.svg": 1401,
	"./sterlingparker/icons/MyAccount.svg": 1402,
	"./sterlingparker/icons/PlaceBetsIconSP.svg": 1403,
	"./sterlingparker/icons/Promo.svg": 1404,
	"./sterlingparker/icons/ResponsibleGambling.svg": 1405,
	"./sterlingparker/icons/Sports.svg": 1406,
	"./sterlingparker/images/logo-location-not-allowed.svg": 1407,
	"./sterlingparker/images/logo.svg": 1408,
	"./sterlingparker/images/logoDesktop.svg": 1409,
	"./sterlingparker/images/logoFooter.svg": 1410,
	"./sterlingparker/images/logoMobile.svg": 1411,
	"./sugarcastle/icons/Badminton.svg": 1412,
	"./sugarcastle/icons/Deposit.svg": 1413,
	"./sugarcastle/icons/Diamond.svg": 1414,
	"./sugarcastle/icons/Home.svg": 1415,
	"./sugarcastle/icons/Margarita.svg": 1416,
	"./sugarcastle/icons/Parchment.svg": 1417,
	"./sugarcastle/icons/ScrewWrench.svg": 1418,
	"./sugarcastle/images/sidenav/logoSidenav.svg": 1419,
	"./templebet/icons/ContactUs.svg": 1420,
	"./templebet/icons/Deposit.svg": 1421,
	"./templebet/icons/MyAccount.svg": 1422,
	"./templebet/icons/ResponsibleGambling.svg": 1423,
	"./templebet/icons/Sports.svg": 1424,
	"./templebet/icons/close.svg": 1425,
	"./templebet/images/backgrounds/background.svg": 1426,
	"./templebet/images/close-filter.svg": 1427,
	"./templebet/images/onboarding/onboardingLogoMb.svg": 1428,
	"./templebet/images/racing/MYSTERYBET.svg": 1429,
	"./titanbet/images/close-filter.svg": 1430,
	"./vikingbet/icons/Account.svg": 1431,
	"./vikingbet/icons/Axe.svg": 1432,
	"./vikingbet/icons/Contact.svg": 1433,
	"./vikingbet/icons/Deposit.svg": 1434,
	"./vikingbet/icons/Home.svg": 1435,
	"./vikingbet/icons/Promotion.svg": 1436,
	"./vikingbet/icons/loadingspinner.svg": 1437,
	"./vikingbet/images/backgrounds/empty.svg": 1438,
	"./vikingbet/images/backgrounds/menu-arrow-left.svg": 1439,
	"./vikingbet/images/backgrounds/menu-arrow-right.svg": 1440,
	"./vikingbet/images/logo.svg": 1441,
	"./volcanobet/icons/Betslip.svg": 1442,
	"./volcanobet/icons/ContactUs.svg": 1443,
	"./volcanobet/icons/Deposit.svg": 1444,
	"./volcanobet/icons/Home.svg": 1445,
	"./volcanobet/icons/LiveChat.svg": 1446,
	"./volcanobet/icons/MultiIconVolcanobet.svg": 1447,
	"./volcanobet/icons/MyAccount.svg": 1448,
	"./volcanobet/icons/Promo.svg": 1449,
	"./volcanobet/icons/ResponsibleGambling.svg": 1450,
	"./volcanobet/icons/Sports.svg": 1451,
	"./volcanobet/images/backgrounds/hero-homepage-bg.svg": 1452,
	"./volcanobet/images/backgrounds/races-header-bg.svg": 1453,
	"./volcanobet/images/backgrounds/races-header-w-sky-bg.svg": 1454,
	"./volcanobet/images/betslip/empty-betslip.svg": 1455,
	"./volcanobet/images/betslip/pattern-top.svg": 1456,
	"./volcanobet/images/loader.svg": 1457,
	"./volcanobet/images/logo.svg": 1458,
	"./volcanobet/images/mobile_logo.svg": 1459,
	"./volcanobet/images/nav/man.svg": 1460,
	"./volcanobet/images/sidenav/mobile/caveman.svg": 1461,
	"./volcanobet/images/sidenav/mobile/ground.svg": 1462,
	"./volcanobet/images/sidenav/mobile/tiger.svg": 1463,
	"./wellbet/images/backgrounds/thumbsUp.svg": 1464,
	"./wellbet/images/backgrounds/welcome.svg": 1465,
	"./wellbet/images/emptyBetslip.svg": 1466,
	"./wellbet/images/emptyBetslipLogo.svg": 1467,
	"./wellbet/images/footer/wblogo.svg": 1468,
	"./wellbet/images/footerLogo.svg": 1469,
	"./wellbet/images/header/wblogo.svg": 1470,
	"./wellbet/images/header/woman.svg": 1471,
	"./wellbet/images/homeFeaturedRacing/featured.svg": 1472,
	"./wellbet/images/homeFeaturedRacing/horses.svg": 1473,
	"./wellbet/images/homeFeaturedRacing/mask.svg": 1474,
	"./wellbet/images/homeFeaturedRacing/ntj.svg": 1475,
	"./wellbet/images/homeFeaturedSport/boats.svg": 1476,
	"./wellbet/images/logo.svg": 1477,
	"./wellbet/images/onboardingLogo.svg": 1478,
	"./wellbet/images/toggle/volleyball.svg": 1479,
	"./wellbet/images/waterbg.svg": 1480
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2439;